module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero.3fdd2fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/fullscreen-image_hero.png
// module id = nQJK
// module chunks = 0